







































































import RouteTab from '@/components/RouteTab.vue';
import { Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import TitleMixin from '@/mixins/title-mixin';
import MilkVatReferencesList from './MilkVatReferencesList.vue';
import MilkVatReferenceAdd from './MilkVatReferenceAdd.vue';
import MilkVatCorrectionSettings from './MilkVatCorrectionsSettings.vue';
import MilkVatCorrectionsHistory from './MilkVatCorrectionsHistory.vue';
import { Vat, VatCorrection } from '@/api';

@Component({
	components: {
		RouteTab,
		MilkVatReferenceAdd,
		MilkVatReferencesList,
		MilkVatCorrectionSettings,
		MilkVatCorrectionsHistory,
	},
})
export default class MilkVatCorrections extends mixins(TitleMixin) {
	@Prop()
	public vat!: Vat;

	public savedReferences: VatCorrection[] = [];

	public parameters: Record<string, string | number | null> = {};
	public correction: Record<string, number | null> = {};

	public referencesList?: MilkVatReferencesList;
	public showMilkVatSettings: boolean = false;

	public created() {
		this.onVatChanged();
	}

	@Watch('vat', { immediate: true, deep: true })
	public onVatChanged(): void {
		this.showMilkVatSettings = !this.vat.emptyDistance;
		setTimeout(() => {
			this.referencesList = <MilkVatReferencesList>this.$refs.referencesList;
		}, 1);

		this.parameters = <Record<string, string | number>>this.vat.formulaParameters;
		this.correction = {};
		Object.keys(this.parameters).forEach(key => {
			this.correction[key] =
				(<any>this.vat?.currentcorrection?.formula_parameters ?? { [key]: 0 })[key] ?? 0;
		});
	}

	public async reloadCorrectionList(
		correctionsSettings?: MilkVatCorrectionSettings,
		reloadFromApi: boolean = false,
	): Promise<void> {
		await this.referencesList?.loadReferences(reloadFromApi);
		await correctionsSettings?.updateVat();
	}

	@Emit('setEmptyDistance')
	public handleSetEmptyDistance(): void {}
}
